import {Component, EventEmitter, Input, Output, SimpleChanges} from '@angular/core';
import {Expose} from "../../interfaces/expose";
import {APIService} from "../../services/api.service";
import {NotificationService} from "../../services/notification.service";
import {AuthenticationService} from "../../services/authentication.service";
import {isNgDiff, sleep} from "../../utils/angular";
import * as uuid from "uuid";
import {CreateExposeTask, CreatePortfolioTask} from "../../interfaces/task";
import {showAPIError} from "../../utils/api";
import {environment} from "../../../environments/environment";
import {ObjectID, Portfolio} from "../../interfaces";

@Component({
  selector: 'pfm-download-portfolio-modal',
  templateUrl: './download-portfolio-modal.component.html',
  styleUrls: ['./download-portfolio-modal.component.scss']
})
export class DownloadPortfolioModalComponent {

  @Input() portfolio: Portfolio|null = null;
  @Output() portfolioChange: EventEmitter<Portfolio|null> = new EventEmitter<Portfolio|null>();

  blobid: ObjectID|null = null;

  state: 'LOADING'|'CREATING'|'ERROR'|'DOWNLOAD' = 'LOADING'

  internalAsyncID: string = '';

  constructor(private api: APIService,
              private notification: NotificationService,
              private auth: AuthenticationService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (isNgDiff(changes, 'portfolio')) {
      if (this.portfolio !== null) {
        this.loadPDF().then(() => {})
      } else {
        this.clear();
      }
    }
  }

  clear() {
    this.state = 'LOADING';
    this.internalAsyncID = '';
  }

  async loadPDF() {
    if (this.portfolio === null) return;

    const iaid = uuid.v4();

    try {
      this.state = 'LOADING';
      this.internalAsyncID = iaid;

      const data = (await Promise.all([this.api.getPortfolioPDF(this.portfolio.id), sleep(850)]))[0];

      if (this.internalAsyncID != iaid) return; // modal closed

      if (data.exists) {
        this.blobid = data.blob!.id;
        this.state = 'DOWNLOAD';
        return;
      }

      const baseTask = await this.api.startCreatePortfolioTasks(this.portfolio.id);

      if (this.internalAsyncID != iaid) return; // modal closed

      this.state = 'CREATING';

      while (true) {

        const task = (await this.api.getTask(baseTask.id)) as CreatePortfolioTask;

        if (this.internalAsyncID != iaid) return; // modal closed

        if (task.status === 'RUNNING') {
          await sleep(100);
          if (this.internalAsyncID != iaid) return; // modal closed
          continue;
        }

        if (task.status === 'FINISHED') {
          this.blobid = task.result!.blobID;
          this.state = 'DOWNLOAD';
          return;
        }

        if (task.status === 'ABORTED') {
          this.state = 'ERROR';
          this.notification.error('Fehler', 'Task wurde abgebrochen');
          return;
        }

        if (task.status === 'FAILED') {
          this.state = 'ERROR';
          this.notification.error('Fehler', task.error);
          return;
        }

        task.status;

        this.state = 'ERROR';
        this.notification.error('Fehler', "Unbekannter API Rückgabewert");
        return;

      }

    } catch (err) {

      this.state = 'ERROR';
      showAPIError(this.notification, 'PDF konnten nicht geladen werden', err);
      return;

    }
  }

  onModalShowChanged(show: boolean) {
    if (!show) {
      this.portfolioChange.emit(this.portfolio = null);
    }
  }

  downloadURL() {
    return `${environment.apiBaseUrl}company/${this.auth.getSelfCompanyID() ?? 'ERR'}/blobs/${this.blobid ?? 'NULL'}/data?xx-bearer-token=@${this.auth.getToken()}`
  }
}
